export const USER_LOGIN_SOCIAL = 'APP/USER_LOGIN_SOCIAL';
export const SIGN_IN_SIGN_UP_WITH_EMAIL = 'APP/SIGN_IN_SIGN_UP_WITH_EMAIL';
export const SET_USER_AUTH_EVENT_DATA = 'APP/SET_USER_AUTH_EVENT_DATA';
export const RESET_USER_AUTH_EVENT_DATA = 'APP/RESET_USER_AUTH_EVENT_DATA';
export const USER_LOGIN_WITH_EMAIL_AND_PASSWORD = 'APP/USER_LOGIN_WITH_EMAIL_AND_PASSWORD';
export const GOOGLE_LOGIN_WITH_CONSENTS = 'APP/GOOGLE_LOGIN_WITH_CONSENTS';
export const PASSWORD_LOGIN_WITH_CONSENTS = 'APP/PASSWORD_LOGIN_WITH_CONSENTS';
export const FACEBOOK_LOGIN_WITH_CONSENTS = 'APP/FACEBOOK_LOGIN_WITH_CONSENTS';
export const UPDATE_USER = 'APP/UPDATE_USER';
export const LOGOUT = 'APP/LOGOUT';
export const SET_TOAST_MESSAGE = 'APP/SET_TOAST_MESSAGE';
export const SET_AUTH_MODAL = 'APP/SET_AUTH_MODAL';
export const SET_INVESTORS_LOGIN_STEP = 'APP/SET_INVESTORS_LOGIN_STEP';
export const SET_COMMUTE_POPUP_STATUS = 'APP/SET_COMMUTE_POPUP_STATUS';
export const SET_MOBILE_DISCOVERY_POPUP_STATUS = 'APP/SET_MOBILE_DISCOVERY_POPUP_STATUS';
export const SET_CONTACT_AGENT_OPEN = 'APP/SET_CONTACT_AGENT_OPEN';
export const SET_FEEDBACK_POPUP_OPEN = 'APP/SET_FEEDBACK_POPUP_OPEN';
export const SET_UPLOAD_BULLETIN_REPORT_MODAL_STATE = 'APP/SET_UPLOAD_BULLETIN_REPORT_MODAL_STATE';
export const SET_AFTER_UPLOAD_BULLETIN_MODAL_OPEN = 'APP/SET_AFTER_UPLOAD_BULLETIN_MODAL_OPEN';
export const SET_ADDRESS_FEEDBACK_POPUP_OPEN = 'APP/SET_ADDRESS_FEEDBACK_POPUP_OPEN';
export const SET_REPORT_LISTING_POPUP_OPEN = 'APP/SET_REPORT_LISTING_POPUP_OPEN';
export const SET_FINISH_FORM_STATE = 'APP/SET_FINISH_FORM_STATE';
export const SHOW_CONTACT_PHONE = 'APP/SHOW_CONTACT_PHONE';
export const SET_UNAPPROVED_AGENT_POPUP_STATUS = 'APP/SET_UNAPPROVED_AGENT_POPUP_STATUS';
export const SET_SHARE_CLOSED_DEAL_POPUP = 'APP/SET_SHARE_CLOSED_DEAL_POPUP';

export const OPEN_AGENT_SUPPORT_MODAL = 'APP/OPEN_AGENT_SUPPORT_MODAL';
export const CLOSE_AGENT_SUPPORT_MODAL = 'APP/CLOSE_AGENT_SUPPORT_MODAL';

export const SET_IS_LISTINGS_TABLE_LOADING = 'APP/SET_IS_LISTINGS_TABLE_LOADING';

export const SET_GALLERY_STATUS = 'APP/SET_GALLERY_STATUS';

export const TOGGLE_FAVORITES = 'APP/TOGGLE_FAVORITES';
export const TOGGLE_ADDRESS = 'APP/TOGGLE_ADDRESS';
export const TOGGLE_LOGIN_SUCCESS = 'APP/TOGGLE_LOGIN_SUCCESS';

export const SAVE_SEARCH = 'APP/SAVE_SEARCH';
export const SAVE_SEARCH_WITH_VALIDATION = 'APP/SAVE_SEARCH_WITH_VALIDATION';
export const CONTINUE_EDITING = 'APP/CONTINUE_EDITING';
export const GET_BACK_TO_EDITING_LATER = 'APP/GET_BACK_TO_EDITING_LATER';
export const UPDATE_SAVED_SEARCH = 'APP/UPDATE_SAVED_SEARCH';
export const UPDATE_SAVED_SEARCH_FREQUENCY = 'APP/UPDATE_SAVED_SEARCH_FREQUENCY';
export const DELETE_SAVE_SEARCH = 'APP/DELETE_SAVE_SEARCH';
export const SET_SAVE_SEARCH_MODAL_OPEN = 'APP/SET_SAVE_SEARCH_MODAL_OPEN';
export const RESOLVE_SAVE_SEARCH_MODAL = 'APP/RESOLVE_SAVE_SEARCH_MODAL';

export const UPDATE_PENDING_ADDRESS_CARD_SETTINGS = 'APP/UPDATE_PENDING_ADDRESS_CARD_SETTINGS';

export const SET_NEEDS_POPUP_OPEN = 'APP/SET_NEEDS_POPUP_OPEN';
export const SET_CONTACT_AGENT_SUCCESS_OPEN = 'APP/SET_CONTACT_MODAL_SUCCESS_OPEN';

export const SET_MOBILE_SEARCH_MAP_VIEW_ACTIVE = 'APP/SET_MOBILE_SEARCH_MAP_VIEW_ACTIVE';
export const SET_VISIBLE_SECTION = 'APP/SET_VISIBLE_SECTION';

export const SET_SAVE_AGENT_RESULT_POPUP_OPEN = 'APP/SET_SAVE_AGENT_RESULT_POPUP_OPEN';

export const SET_FIXED_MULTI_PREVIEW = 'APP/SET_FIXED_MULTI_PREVIEW';

export const SET_USER_MOBILE_PROFILE_OPEN = 'APP/SET_USER_MOBILE_PROFILE_OPEN';

export const SET_SIDEBAR_OPEN = 'APP/SET_SIDEBAR_OPEN';

export const SET_USER_MOBILE_PROFILE_RETURNABLE = 'APP/SET_USER_MOBILE_PROFILE_RETURNABLE';

export const SUBMIT_CONTACT_AGENT = 'APP/SUBMIT_CONTACT_AGENT';

export const SUBMIT_USER_CONTACT_AGENT = 'APP/SUBMIT_USER_CONTACT_AGENT';

export const SET_SHARE_MODAL_OPEN = 'APP/SET_SHARE_MODAL_OPEN';

export const CONTACT_MODAL_CALL = 'APP/CONTACT_MODAL_CALL';

export const SET_MADAD_CONTACT_MODAL_STATE = 'APP/SET_MADAD_CONTACT_MODAL_STATE';

export const SET_TABU_STATE = 'APP/SET_TABU_STATE';
export const REQUEST_TABU_BY_DOC_ID = 'APP/REQUEST_TABU_BY_DOC_ID';

export const SET_AUTH_EMAIL = 'APP/SET_AUTH_EMAIL';

export const SET_MANAGE_LISTINGS_ERROR_MODAL = 'APP/SET_MANAGE_LISTINGS_ERROR_MODAL';
export const CLOSE_MANAGE_LISTINGS_ERROR_MODAL = 'APP/CLOSE_MANAGE_LISTINGS_ERROR_MODAL';
export const SET_UPDATE_LISTING_STATUS_MODAL_TYPE = 'APP/SET_UPDATE_LISTING_STATUS_MODAL_TYPE';
export const SET_MANAGE_LISTINGS_FILTER_AGENT_USER_ID = 'APP/SET_MANAGE_LISTINGS_FILTER_AGENT_USER_ID';

export const SET_MORTGAGE_MODAL = 'APP/SET_MORTGAGE_MODAL';
export const SET_DEVELOPER_FILTERS = 'APP/SET_DEVELOPER_FILTERS';
export const SET_IS_LISTING_ADDITIONAL_BANNER_CLOSED = 'APP/SET_IS_LISTING_ADDITIONAL_BANNER_CLOSED';
export const SET_IS_SEARCH_RESULT_ADDITIONAL_BANNER_CLOSED = 'APP/SET_IS_SEARCH_RESULT_ADDITIONAL_BANNER_CLOSED';
export const SET_IS_MOBILE_MENU_HIDDEN = 'APP/SET_IS_MOBILE_MENU_HIDDEN';

export const SET_MORTGAGE_FORM_SOURCE = 'APP/SET_MORTGAGE_FORM_SOURCE';

export const SET_IS_MIZRAHI_BANK_MODAL_OPEN = 'APP/SET_IS_MIZRAHI_BANK_MODAL_OPEN';
export const SET_IS_YIELD_TAG_MODAL_OPEN = 'APP/SET_IS_YIELD_TAG_MODAL_OPEN';

export const SET_AGENT_OFFICE_CONTACT_POPUP_OPEN = 'APP/SET_AGENT_OFFICE_CONTACT_POPUP_OPEN';
export const SET_MORTGAGE_OFFICE_CONTACT_POPUP_OPEN = 'APP/SET_MORTGAGE_OFFICE_CONTACT_POPUP_OPEN';

export const SET_COMMITTED_SEARCH_VIEW_MODE = 'APP/SET_COMMITTED_SEARCH_VIEW_MODE';
export const SET_INTERMEDIATE_SEARCH_VIEW_MODE = 'APP/SET_INTERMEDIATE_SEARCH_VIEW_MODE';

export const SET_IS_LIKED_TOAST_OPEN = 'APP/SET_IS_LIKED_TOAST_OPEN';
export const SET_INVESTORS_FEEDBACK_MODAL_STATE = 'APP/SET_INVESTORS_FEEDBACK_MODAL_STATE';

export const CONTACT_AGENT_INPUT_CLICK = 'APP/CONTACT_AGENT_INPUT_CLICK';

export const SET_IS_HEADER_TAB_SUBMENU_VISIBLE = 'APP/SET_IS_HEADER_TAB_SUBMENU_VISIBLE';

export const SET_PUSH_NOTIFICATIONS_MODAL_TYPE = 'APP/SET_PUSH_NOTIFICATIONS_MODAL_TYPE';

export const SET_DEVICE_PUSH_STATUS = 'APP/SET_DEVICE_PUSH_STATUS';
export const SET_LISTING_EDITED = 'APP/SET_LISTING_EDITED';

export const SET_DEAL_AFFILIATION_POPUP = 'APP/SET_DEAL_AFFILIATION_POPUP';
export const SET_NEW_UNIT_PAGE_MAP_EXPANDED = 'APP/SET_NEW_UNIT_PAGE_MAP_EXPANDED';

export const SET_MOBILE_DISCOVERY_DISABLED = 'APP/SET_MOBILE_DISCOVERY_DISABLED';
export const SET_MOBILE_DISCOVERY_ENABLED = 'APP/SET_MOBILE_DISCOVERY_ENABLED';

export const SET_INTENT_MODAL_OPEN = 'APP/SET_INTENT_MODAL_OPEN';
export const SET_WELCOME_MODAL_OPEN = 'APP/SET_WELCOME_MODAL_OPEN';

export const SET_CONTACT_FORM_EVENTS_SOURCE = 'APP/SET_CONTACT_FORM_EVENTS_SOURCE';

export const INITIATE_PAYMENT = 'APP/INITIATE_PAYMENT';

export const SET_GA_LOAD_TIMESTAMP = 'APP/SET_GA_LOAD_TIMESTAMP';

export const SET_PRIVATE_USER_MONETIZATION_EVENTS_SOURCE = 'APP/SET_PRIVATE_USER_MONETIZATION_EVENTS_SOURCE';
export const FETCH_SOLD_DEAL_BANNER_DATA = 'APP/FETCH_SOLD_DEAL_BANNER_DATA';
export const RESET_SOLD_DEAL_BANNER_DATA = 'APP/RESET_SOLD_DEAL_BANNER_DATA';

export const SET_NOTIFICATION_BANNER_MESSAGE = 'APP/SET_NOTIFICATION_BANNER_MESSAGE';
export const SET_MENU_DOT_VISIBLE = 'APP/SET_MENU_DOT_VISIBLE';
export const SET_SAVED_SEARCH_ACTIVE_MODAL = 'APP/SET_SAVED_SEARCH_ACTIVE_MODAL';

export const SET_INVESTORS_SUBHEADER_ACTIVE_SECTION = 'APP/SET_INVESTORS_SUBHEADER_ACTIVE_SECTION';

export const SET_INVESTORS_COMPARE_MODAL_OPEN = 'APP/SET_INVESTORS_COMPARE_MODAL_OPEN';
export const SET_INVESTORS_RECENT_SEARCH_ID = 'APP/SET_INVESTORS_RECENT_SEARCH_ID';

export const SET_COOKIE_CONSENT_MODAL_OPEN = 'APP/SET_COOKIE_CONSENT_MODAL_OPEN';

export const SET_HOSTED_FIELDS_MODAL_STATE = 'APP/SET_HOSTED_FIELDS_MODAL_STATE';
export const SET_HOSTED_FIELDS_SUCCESS_MODAL = 'APP/SET_HOSTED_FIELDS_SUCCESS_MODAL';
export const SET_HOSTED_FIELDS_SUCCESS_UPLOAD_MODAL = 'APP/SET_HOSTED_FIELDS_SUCCESS_UPLOAD_MODAL';
export const SET_HOSTED_FIELDS_FAIL_MODAL = 'APP/SET_HOSTED_FIELDS_FAIL_MODAL';
export const SET_HOSTED_FIELDS_FAIL_UPLOAD_MODAL = 'APP/SET_HOSTED_FIELDS_FAIL_UPLOAD_MODAL';
export const SET_HOSTED_FIELDS_MODAL_ERRORS_STATE = 'APP/SET_HOSTED_FIELDS_MODAL_ERRORS_STATE';
export const SUBMITTED_PAYMENT_VIA_HOSTED_FIELDS = 'APP/SUBMITTED_PAYMENT_VIA_HOSTED_FIELDS';
export const TRANZILA_HOSTED_FIELDS_PENDING_PAYMENT = 'APP/TRANZILA_HOSTED_FIELDS_PENDING_PAYMENT';
export const SET_HOSTED_FIELDS_GOOGLE_ENABLE_BUTTON = 'APP/SET_HOSTED_FIELDS_GOOGLE_ENABLE_BUTTON';

export const SET_AFTER_LISING_DELETE_MODAL_OPEN = 'APP/SET_AFTER_LISING_DELETE_MODAL_OPEN';
